module.exports = __webpack_public_path__ + "img/product-icon_2.4e8b4c3d.png";